export const search = {
  inputs: [
    // ---------- 筛选区第1行
    {
      type: 'InputText',
      title: 'Item Key',
      span: 6,
      placeholder: 'Item Name or Helper Code',
      getter: 'state/search/baseProduct/name',
      setter: 'commit/search/setBaseProductName',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Category',
      span: 6,
      options: 'getters/categoriesAll',
      getter: 'state/search/baseProduct/category',
      setter: 'commit/search/setBaseProductCategory',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Brands',
      span: 12,
      options: 'getters/brandsAll',
      getter: 'state/search/baseProduct/brand',
      setter: 'commit/search/setBaseProductBrand',
      defaultValue: 0
    },
    // ---------- 筛选区第2行
    {
      type: 'InputText',
      title: 'TAG L1',
      span: 6,
      placeholder: 'Item Tag level 1',
      getter: 'state/search/baseProduct/tag1',
      setter: 'commit/search/setBaseProductTag1'
      // defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'TAG L2',
      span: 6,
      placeholder: 'Item Tag level 2',
      getter: 'state/search/baseProduct/tag2',
      setter: 'commit/search/setBaseProductTag2'
      // defaultValue: 0
    },
    {
      type: 'InputText',
      title: '3P Code',
      span: 6,
      placeholder: 'Item Tag level 3',
      getter: 'state/search/baseProduct/tag3',
      setter: 'commit/search/setBaseProductTag3'
      // defaultValue: 0
    },
    {
      type: 'InputText',
      title: 'Location',
      span: 6,
      placeholder: 'Warehouse Location',
      getter: 'state/search/baseProduct/tag4',
      setter: 'commit/search/setBaseProductTag4'
      // defaultValue: 0
    },
    // ---------- 筛选区第3行
    {
      type: 'InputDateRangePicker',
      title: 'Create Date',
      span: 6,
      getter: 'state/search/baseProduct/createDateRange',
      setter: 'commit/search/setBaseProductCreateRange'
    },
    {
      type: 'InputDateRangePicker',
      title: 'Modify Date',
      span: 6,
      getter: 'state/search/baseProduct/modifyDateRange',
      setter: 'commit/search/setBaseProductModifyRange'
    },
    {
      type: 'InputSelect',
      title: 'Sort Type',
      span: 6,
      options: 'state/search/baseProductSortTypes',
      getter: 'state/search/baseProduct/sortType',
      setter: 'commit/search/setBaseProductSortType',
      defaultValue: 0
    },
    {
      type: 'InputSelect',
      title: 'Xero Sent',
      span: 6,
      options: 'getters/search/xeroSends',
      getter: 'state/search/baseProduct/xeroSend',
      setter: 'commit/search/setBaseProductXeroSend',
      defaultValue: 0
    }
  ],
  lines: [
    {
      prop: 'code',
      label: 'Item Code',
      width: 170
    },
    {
      prop: 'name',
      label: 'Item Name',
      width: 340
    },
    {
      prop: 'tag1',
      label: 'Tag L1.',
      width: 105
    },
    {
      prop: 'tag2',
      label: 'Tag L2.',
      width: 105
    },
    {
      prop: 'tag3',
      label: '3P Code.',
      width: 105
    },
    {
      prop: 'tag4',
      label: 'Location.',
      width: 150
    },
    // {
    //   prop: 'ref_pur',
    //   label: 'Ref Pur',
    //   width: 75,
    //   align: 'right',
    //   className: 'table-column-cost-type-color'
    // },
    // {
    //   prop: 'standardPrice',
    //   label: 'Standard',
    //   width: 80,
    //   align: 'right',
    //   className: 'table-column-sale-type-color'
    // },
    {
      prop: 'classAPrice',
      label: 'A price',
      width: 75,
      align: 'right',
      className: 'table-column-class-type-color'
    },
    {
      prop: 'classBPrice',
      label: 'B price',
      width: 75,
      align: 'right',
      className: 'table-column-class-type-color'
    },
    {
      prop: 'specialPrice',
      label: 'Special',
      width: 75,
      align: 'right',
      className: 'table-column-sale-type-color'
    },
    {
      prop: 'standardPrice',
      label: 'VIP price',
      width: 75,
      align: 'right',
      className: 'table-column-sale-type-color'
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 100
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 100
    },
    {
      prop: 'xeroSent',
      label: 'Xero',
      width: 60
    },
    {
      prop: 'ColumnViewBaseinfoBtn',
      label: 'Action',
      align: 'center'
    }
  ]
}

const add = {
  inputs: [
    // ------------编码及基本 0---5
    {
      type: 'InputText',
      title: 'Item Code',
      span: 6,
      placeholder: 'Item Code',
      getter: 'state/baseinfo/product/code',
      setter: 'commit/baseinfo/setProductCode',
      width: 200,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Origin Code',
      span: 6,
      placeholder: 'Origin Code',
      getter: 'state/baseinfo/product/originCode',
      setter: 'commit/baseinfo/setOriginCode',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Helper Code',
      span: 6,
      placeholder: 'Helper Code',
      getter: 'state/baseinfo/product/helperCode',
      setter: 'commit/baseinfo/setHelperCode',
      width: 200,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Unit',
      span: 6,
      placeholder: 'Unit',
      getter: 'state/baseinfo/product/unit',
      setter: 'commit/baseinfo/setProductUnit',
      defaultValue: 'Pcs',
      width: 200,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Item Name',
      span: 12,
      placeholder: 'Item Name',
      getter: 'state/baseinfo/product/name',
      setter: 'commit/baseinfo/setProductName',
      width: 600,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Comment',
      span: 12,
      placeholder: 'Comment for this product',
      getter: 'state/baseinfo/product/comments',
      setter: 'commit/baseinfo/setProductComment',
      width: 600
    },
    // ------------类别控制 6,7
    {
      type: 'InputSelect',
      title: 'Category',
      span: 6,
      options: 'state/categories',
      getter: 'state/baseinfo/product/category',
      setter: 'commit/baseinfo/setProductCategory',
      defaultValue: '',
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Auto Part Type',
      span: 6,
      options: 'getters/autoPartsTypes',
      getter: 'state/baseinfo/product/auto_parts_type',
      setter: 'commit/baseinfo/setProductAutoPartsType',
      defaultValue: '',
      isRequire: true
    },
    // ------------品牌 tag 8--14
    {
      type: 'InputSelect',
      title: 'Brand',
      span: 6,
      options: 'getters/brandsNormal',
      getter: 'state/baseinfo/product/brand',
      setter: 'commit/baseinfo/setProductbrand',
      defaultValue: '',
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Show for Shop',
      span: 6,
      options: 'state/baseinfo/boolSelect',
      getter: 'state/baseinfo/product/is_customer_show',
      setter: 'commit/baseinfo/setProductIsCustomerShow',
      defaultValue: 1,
      isRequire: true
    },
    {
      type: 'InputSelect',
      title: 'Manufacturer',
      span: 12,
      placeholder: 'Manufacturer of this brand',
      options: 'getters/baseinfo/facOptions',
      getter: 'state/baseinfo/product/manufacturer',
      setter: 'commit/baseinfo/setProductManufacturer',
      width: 200
    },
    {
      type: 'InputSelect',
      title: 'Tag1',
      span: 6,
      options: 'getters/baseinfo/prodTag1Type',
      getter: 'state/baseinfo/product/tag1',
      setter: 'commit/baseinfo/setProductTag1',
      defaultValue: '',
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Tag2(New Loc.)',
      span: 6,
      getter: 'state/baseinfo/product/tag2',
      setter: 'commit/baseinfo/setProductTag2',
      defaultValue: ''
    },
    {
      type: 'InputText',
      title: '3P Code',
      span: 6,
      getter: 'state/baseinfo/product/tag3',
      setter: 'commit/baseinfo/setProductTag3',
      defaultValue: ''
    },
    {
      type: 'InputText',
      title: 'Location',
      span: 6,
      getter: 'state/baseinfo/product/tag4',
      setter: 'commit/baseinfo/setProductTag4',
      defaultValue: ''
    },
    // ------------价格控制 全部取消编辑
    // {
    //   type: 'InputText',
    //   title: 'Standard Price',
    //   span: 6,
    //   placeholder: 'Standard Price',
    //   getter: 'state/baseinfo/product/standardPrice',
    //   setter: 'commit/baseinfo/setProductStandardPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Class A',
    //   span: 6,
    //   placeholder: 'A Price',
    //   getter: 'state/baseinfo/product/classAPrice',
    //   setter: 'commit/baseinfo/setProductAPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Class B',
    //   span: 6,
    //   placeholder: 'B Price',
    //   getter: 'state/baseinfo/product/classBPrice',
    //   setter: 'commit/baseinfo/setProductBPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Class C',
    //   span: 6,
    //   placeholder: 'C Price',
    //   getter: 'state/baseinfo/product/classCPrice',
    //   setter: 'commit/baseinfo/setProductCPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Class D',
    //   span: 6,
    //   placeholder: 'D Price',
    //   getter: 'state/baseinfo/product/classDPrice',
    //   setter: 'commit/baseinfo/setProductDPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Class E',
    //   span: 6,
    //   placeholder: 'E Price',
    //   getter: 'state/baseinfo/product/classEPrice',
    //   setter: 'commit/baseinfo/setProductEPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Ref Purchase',
    //   span: 6,
    //   placeholder: 'Ref Purchase Price',
    //   getter: 'state/baseinfo/product/ref_pur',
    //   setter: 'commit/baseinfo/setProductRefPurPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputText',
    //   title: 'Special',
    //   span: 6,
    //   placeholder: 'Special Price',
    //   getter: 'state/baseinfo/product/specialPrice',
    //   setter: 'commit/baseinfo/setProductSpecialPrice',
    //   width: 200
    // },
    // {
    //   type: 'InputSelect',
    //   title: 'Special or not',
    //   span: 6,
    //   options: 'state/baseinfo/boolSelect',
    //   getter: 'state/baseinfo/product/is_special',
    //   setter: 'commit/baseinfo/setProductIsSpecial',
    //   defaultValue: 0
    // },
    // {
    //   type: 'InputSelect',
    //   title: 'Clearance or not',
    //   span: 6,
    //   options: 'state/baseinfo/boolSelect',
    //   getter: 'state/baseinfo/product/is_clearence',
    //   setter: 'commit/baseinfo/setProductIsClearance',
    //   defaultValue: 0
    // },

    // ------------参数Tyre 15--22
    {
      type: 'InputText',
      title: 'Model',
      span: 6,
      placeholder: 'Tyre Model',
      getter: 'state/baseinfo/product/tyreModel',
      setter: 'commit/baseinfo/setProductTyreModel',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Specification',
      span: 6,
      placeholder: 'Tyre Specification',
      getter: 'state/baseinfo/product/specification',
      setter: 'commit/baseinfo/setProductSpecification',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Diameter',
      span: 6,
      placeholder: 'Tyre Diameter',
      getter: 'state/baseinfo/product/diameter',
      setter: 'commit/baseinfo/setProductDiameter',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Patterns',
      span: 6,
      placeholder: 'Tyre Patterns',
      getter: 'state/baseinfo/product/patterns',
      setter: 'commit/baseinfo/setProductPatterns',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Width',
      span: 6,
      placeholder: 'Tyre Width',
      getter: 'state/baseinfo/product/width',
      setter: 'commit/baseinfo/setProductWidth',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Load Rate',
      span: 6,
      placeholder: 'Tyre Load Rate',
      getter: 'state/baseinfo/product/load_rate',
      setter: 'commit/baseinfo/setProductLoadRate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Speed Rate',
      span: 6,
      placeholder: 'Tyre Speed Rate',
      getter: 'state/baseinfo/product/speed_rate',
      setter: 'commit/baseinfo/setProductSpeedRate',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Suggested',
      span: 6,
      placeholder: 'Suggested car types',
      getter: 'state/baseinfo/product/suggested',
      setter: 'commit/baseinfo/setProductSuggested',
      width: 200
    },
    // ------------参数Wheel 23--28
    {
      type: 'InputSelect',
      title: 'Material',
      span: 6,
      placeholder: 'Material',
      options: 'state/materials',
      getter: 'state/baseinfo/product/material',
      setter: 'commit/baseinfo/setProductMaterial',
      width: 200,
      isRequire: true
    },
    {
      type: 'InputText',
      title: 'Rim Diameter',
      span: 6,
      placeholder: 'Rim Diameter',
      getter: 'state/baseinfo/product/rim_diameter',
      setter: 'commit/baseinfo/setProductRimDiameter',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Rim Width',
      span: 6,
      placeholder: 'Rim Width',
      getter: 'state/baseinfo/product/rim_width',
      setter: 'commit/baseinfo/setProductRimWidth',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Offset',
      span: 6,
      placeholder: 'Offset',
      getter: 'state/baseinfo/product/offset',
      setter: 'commit/baseinfo/setProductOffset',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Center Bore',
      span: 6,
      placeholder: 'Center Bore',
      getter: 'state/baseinfo/product/center_bore',
      setter: 'commit/baseinfo/setProductCenterBore',
      width: 200
    },
    {
      type: 'InputText',
      title: 'Bolt Pattern',
      span: 6,
      placeholder: 'Bolt Pattern',
      getter: 'state/baseinfo/product/bolt_pattern',
      setter: 'commit/baseinfo/setProductBoltPattern',
      width: 200
    }
  ]
}

const edit = {}

edit.inputs = add.inputs.slice()
edit.inputs[0] = {
  type: 'InputText',
  title: 'Item Code',
  span: 6,
  placeholder: 'Item Code',
  getter: 'state/baseinfo/product/code',
  setter: 'commit/baseinfo/setProductCode',
  width: 200,
  disabled: true
}

edit.inputs[4] = {
  type: 'InputText',
  title: 'Item Name',
  span: 12,
  placeholder: 'Item Name',
  getter: 'state/baseinfo/product/name',
  setter: 'commit/baseinfo/setProductName',
  width: 600,
  disabled: true,
  isRequire: true
}

edit.inputs[6] = {
  type: 'InputSelect',
  title: 'Category',
  span: 6,
  options: 'state/categories',
  getter: 'state/baseinfo/product/category',
  setter: 'commit/baseinfo/setProductCategory',
  disabled: true,
  isRequire: true
}

export default { search, add, edit }
